<template>
  <div class="wrapper">
    <Tabs v-model="activeTab" @input="changeTab" class="empty-tab">
      <Tab
        :key="`tab-${index}`"
        v-for="(item, index) of authorizedTabs"
        :header="item.label"
      >
      </Tab>
    </Tabs>
    <router-view></router-view>
  </div>
</template>

<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

export default {
  components: {
    Tabs,
    Tab,
  },

  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          label: "Application coach",
          name: "dynamic-content-coach-app",
          requiredPermission: "DYNAMIC_CONTENT_COACH_APP_READ",
          children: [
            "dynamic-content-coach-app-special-events",
            "dynamic-content-coach-app-app-updates",
            "dynamic-content-coach-app-tutorials",
          ],
        },
        {
          label: "Application client",
          name: "dynamic-content-client-app",
          requiredPermission: "DYNAMIC_CONTENT_CLIENT_APP_READ",
          children: [
            "dynamic-content-client-app-news",
            "dynamic-content-client-app-notifications",
          ],
        },
      ],
    };
  },

  computed: {
    authorizedTabs() {
      return this.tabs.filter((tab) => {
        return this.hasPermission(
          this.$store.state.user,
          tab.requiredPermission,
        );
      });
    },
  },

  created() {
    this.setCurrentTab(this.$route.name);
  },

  methods: {
    changeTab(index) {
      if (index >= 0) {
        this.$router.push({ name: this.authorizedTabs[index].name });
      }
    },

    setCurrentTab(currentPath) {
      this.activeTab = this.authorizedTabs.findIndex(
        (tab) =>
          tab.name === currentPath || tab.children?.includes(currentPath),
      );
    },
  },

  watch: {
    $route(current) {
      this.setCurrentTab(current.name);
    },
  },
};
</script>
<style lang="scss">
.empty-tab {
  .nav.nav-tabs {
    margin-bottom: 15px;
  }
  & > .tab-content {
    display: none;
  }
}
.display-tab {
  .tab-content {
    display: block !important;
  }
}
</style>
